import type { OverdueItemEntry } from "#/types/report";
import { exportToCSV } from "#/utils/CsvUtils";
import { sanitizeItemStatusLabel } from "#/utils/StringUtils";
import moment from "moment";

type Translate = (key: string) => string;

interface ExportOverdueItemsCsvOptions {
  items: OverdueItemEntry[];
  filenamePrefix: string;
  includeScanAge: boolean;
  t: Translate;
}

export function exportOverdueItemsCsv({
  items,
  filenamePrefix,
  includeScanAge,
  t,
}: ExportOverdueItemsCsvOptions): void {
  const rows = items.map((item) => ({
    itemId: item.externalId || `#${item.itemId}`,
    product: item.productName || item.productSku || "",
    site: item.siteName || "",
    status: item.status ? sanitizeItemStatusLabel(item.status) : "",
    daysSinceLastScan: item.daysSinceLastScan ?? "",
    lastScanDate: item.lastScanDate
      ? moment.utc(item.lastScanDate).format("DD/MM/YYYY HH:mm")
      : "",
    estimatedValue: item.estimatedValue,
  }));

  const baseHeaders = ["itemId", "product", "site", "status"];
  const headers = includeScanAge
    ? [...baseHeaders, "daysSinceLastScan", "lastScanDate", "estimatedValue"]
    : [...baseHeaders, "estimatedValue"];

  const headerLabels: Record<string, string> = {
    itemId: t("reports.inventoryScan.overdue.itemId"),
    product: t("reports.inventoryScan.overdue.product"),
    site: t("reports.inventoryScan.overdue.site"),
    status: t("reports.inventoryScan.overdue.status"),
    daysSinceLastScan: t("reports.inventoryScan.overdue.daysSinceLastScan"),
    lastScanDate: "Last Scan Date (UTC)",
    estimatedValue: t("reports.inventoryScan.overdue.estValue"),
  };

  const filename = `${filenamePrefix}-${moment().format("YYYY-MM-DD-HHmmss")}.csv`;
  exportToCSV(rows, headers, filename, headerLabels, t("common.utcNote"));
}
